<script setup lang="ts">
const props = defineProps({
  total: {
    type: Number,
    required: true
  },
  current: {
    type: Number,
    required: true
  }
})

const computedPages = computed(() => {
  const pages = []
  const start = Math.max(1, props.current - 1)
  const end = Math.min(props.total, props.current + 1)

  if (start > 1) pages.push(1)

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  if (end < props.total) pages.push(props.total)

  return pages
})

defineEmits(['handleClick'])
</script>

<template>
  <div id="pagination-list">
    <template v-for="(p, i) in computedPages" :key="`page-item-${i}`">
      <div v-if="p == props.total && props.current < props.total - 2" class="dot">···</div>
      <div
        :class="`page-item clickable ${props.current == p ? 'current' : ''}`"
        @click="$emit('handleClick', p)"
      >
        {{ p }}
      </div>
      <div v-if="p == 1 && props.current > 3" class="dot">···</div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
#pagination-list {
  display: flex;
  justify-content: center;
  gap: 3px;
  margin-top: 30px;

  $size: 35px;

  .page-item {
    height: $size;
    /* width: $size; */
    min-width: $size;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--borderM2);
    border-radius: 7px;
    background-color: white;
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--textMedium);
    position: relative;
  }

  .current {
    background-color: var(--lightPurple);
    color: var(--purple);
    border-color: var(--purple);
  }

  .start {
    margin-right: 20px;
  }

  .dot {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
  }

  .end {
    margin-left: 20px;
  }

  .end::before,
  .start::before {
    content: '...';
    position: absolute;
    bottom: 0;
    height: 90%;
    width: 30px;
    right: -30px;
    text-align: center;
  }

  .end::before {
    right: auto;
    left: -30px;
  }
}

@media (max-width: 600px) {
  #pagination-list {
    .page-item {
      $size: 37px;
      height: $size;
      width: $size;
    }
  }
}

@media (hover: hover) {
  #pagination-list {
    .page-item:hover {
      border-color: var(--purple);
    }
  }
}
</style>
